// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import Meta from 'vue-meta'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import http from './api/http'
import * as filters from './utils/filter'

Vue.prototype.$http = http
Vue.prototype.situationImgUrl = 'https://www.flikef.com/public/img/article/'
// Vue.prototype.situationImgUrl = 'http://127.0.0.1:3020/img/article/'
Vue.config.productionTip = false

// 添加全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})


Vue.use(ElementUI)
Vue.use(Meta)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js